<template>
  <div>
    <navigation />
    <div class="tasklist-container">
      <!-- <button @click="toggleTaskList()" style="height: 33px;">独立审核</button> -->
      <ApproveTaskList v-if="listTab === 'approve'" :approve-task-list="approveTaskList" style="margin-top:26px;" />
      <div class="tasklist" v-if="listTab === 'all'">
        <tasklist :task-list="taskList" :page-size="pageSize" :page-index="pageIndex" :item-total="itemTotal" />
        <pagination
          :page-size="pageSize"
          :page-index="pageIndex"
          :item-total="itemTotal"
          @changeindex="changePageIndex"
          @changesize="changePageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import tasklist from '@/components/tasklist';
import ApproveTaskList from '@/components/ApproveTaskList';
import pagination from '@/components/pagination';
import navigation from '@/components/navigation';
import * as api from '@/api/api.js';

export default {
  data() {
    return {
      taskList: [],
      approveTaskList: [],
      listTab: 'all', //all:所有任务 approve:独立审核任务
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
    };
  },
  components: {
    tasklist,
    pagination,
    navigation,
    ApproveTaskList,
  },
  mounted: function() {
    this.getTaskList();
  },
  methods: {
    toggleTaskList() {
      this.listTab = this.listTab === 'all' ? 'approve' : 'all';
    },
    getTaskList() {
      api
        .getTaskList({ page: this.pageIndex, pagesize: this.pageSize })
        .then(res => {
          this.taskList = res.data.tasks;
          this.itemTotal = res.data.taskCount;
        })
        .catch(() => {});
    },
    changePageIndex: function(pi) {
      this.pageIndex = pi;
      this.getTaskList();
    },
    changePageSize: function(ps) {
      this.pageSize = parseInt(ps);
      this.pageIndex = 0;
      this.getTaskList();
    },
  },
};
</script>
<style type="text/css" scoped>
.tasklist {
  margin-top: 36px;
}
</style>
